module.exports = __webpack_public_path__ + "img/yt.3cf3083a.svg";